// Centralised date/time formatting helpers for consistent 年月日 rendering
// across the entire app. Display-only — never used for database storage.

/**
 * Coerce an arbitrary date input (string or Date) into a Date object.
 * Returns null when the input is falsy or unparseable.
 */
function _toDate(input) {
    if (input === null || input === undefined || input === "") return null;
    if (input instanceof Date) return isNaN(input.getTime()) ? null : input;
    const s = String(input).trim();
    if (!s) return null;
    // Plain "YYYY-MM-DD" should not get pulled into UTC midnight (which can
    // shift to the previous day in JST). Construct a local date instead.
    const ymd = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (ymd) {
        return new Date(parseInt(ymd[1]), parseInt(ymd[2]) - 1, parseInt(ymd[3]));
    }
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
}

function _pad(n) {
    return n < 10 ? `0${n}` : String(n);
}

/**
 * `2026-05-05` (or Date) → `2026年5月5日`
 */
export function fmtYmd(input, fallback = "") {
    const d = _toDate(input);
    if (!d) return fallback;
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
}

/**
 * Same as fmtYmd but appended with `HH:MM` in 24-hour clock.
 * `2026-05-05T12:30:45Z` → `2026年5月5日 21:30` (when TZ=JST)
 */
export function fmtYmdTime(input, fallback = "") {
    const d = _toDate(input);
    if (!d) return fallback;
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 ${_pad(d.getHours())}:${_pad(d.getMinutes())}`;
}

/**
 * Year/month/day + HH:MM:SS (audit logs, GPS tracks, scheduler runs)
 */
export function fmtYmdSeconds(input, fallback = "") {
    const d = _toDate(input);
    if (!d) return fallback;
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 ${_pad(d.getHours())}:${_pad(d.getMinutes())}:${_pad(d.getSeconds())}`;
}
